(function () {
  'use strict';

  if (!window.theme || !theme.RecentlyViewed || !theme.recentlyViewed) return;

  var requests = {};

  function sectionLimit() {
    var section = document.querySelector('[data-section-type="recently-viewed"]');
    var limit = section ? parseInt(section.getAttribute('data-recent-count'), 10) : 5;
    return Number.isFinite(limit) && limit > 0 ? limit : 5;
  }

  function trimRecentHistory() {
    var recent = theme.recentlyViewed.recent || {};
    var keys = Object.keys(recent).filter(function (handle) {
      return handle && handle !== 'undefined';
    });
    var keep = sectionLimit() + 1;

    if (keys.length <= keep) return;

    var trimmed = {};
    keys.slice(-keep).forEach(function (handle) {
      trimmed[handle] = recent[handle];
    });

    theme.recentlyViewed.recent = trimmed;

    if (theme.config && theme.config.hasLocalStorage) {
      try {
        window.localStorage.setItem('theme-recent', JSON.stringify(trimmed));
      } catch (e) {}
    }
  }

  function asJsonString(value) {
    if (!value) return null;
    return typeof value === 'string' ? value : JSON.stringify(value);
  }

  function persistProductInfo() {
    if (!theme.config || !theme.config.hasSessionStorage) return;

    try {
      window.sessionStorage.setItem('recent-products', JSON.stringify(theme.recentlyViewed.productInfo || {}));
    } catch (e) {}
  }

  function productUrl(handle) {
    var root = theme.routes && theme.routes.home ? theme.routes.home : '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root + 'products/' + encodeURIComponent(handle) + '.js';
  }

  function getProductInfoFast(handle) {
    if (!handle || handle === 'undefined') return Promise.resolve(null);

    var cached = theme.recentlyViewed.productInfo && asJsonString(theme.recentlyViewed.productInfo[handle]);
    if (cached) return Promise.resolve(cached);

    if (requests[handle]) return requests[handle];

    requests[handle] = fetch(productUrl(handle), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Recently viewed product request failed');
        return response.text();
      })
      .then(function (text) {
        try {
          var product = JSON.parse(text);
          if (product && product.handle) {
            theme.recentlyViewed.productInfo = theme.recentlyViewed.productInfo || {};
            theme.recentlyViewed.productInfo[product.handle] = text;
            persistProductInfo();
          }
        } catch (e) {}
        return text;
      })
      .catch(function () {
        return null;
      });

    return requests[handle];
  }

  function captureProductDetailsFast(products) {
    theme.recentlyViewed.productInfo = theme.recentlyViewed.productInfo || {};

    (products || []).forEach(function (raw) {
      if (!raw) return;

      try {
        var text = asJsonString(raw);
        var product = JSON.parse(text);
        if (product && product.handle) {
          theme.recentlyViewed.productInfo[product.handle] = text;
        }
      } catch (e) {}
    });

    persistProductInfo();
  }

  function prefetchRecentProducts() {
    var recent = theme.recentlyViewed.recent || {};
    Object.keys(recent).forEach(function (handle) {
      if (handle && handle !== 'undefined') getProductInfoFast(handle);
    });
  }

  function schedulePrefetch() {
    var run = function () {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(prefetchRecentProducts, { timeout: 600 });
      } else {
        window.setTimeout(prefetchRecentProducts, 150);
      }
    };

    var section = document.querySelector('[data-section-type="recently-viewed"]');
    if (!section || !('IntersectionObserver' in window)) {
      run();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      observer.disconnect();
      run();
    }, { rootMargin: '900px 0px' });

    observer.observe(section);
  }

  trimRecentHistory();

  // Keep the native Impulse renderer, but bound its product requests to the
  // number of cards the section can actually display and repair its session cache.
  theme.RecentlyViewed.prototype.getProductInfo = getProductInfoFast;
  theme.RecentlyViewed.prototype.captureProductDetails = captureProductDetailsFast;

  schedulePrefetch();
})();
